import { action } from 'satcheljs';

/**
 * action for setting the flag isLoading in the active View state to the value passed
 * @param isLoading - the new value to be set
 * For use only within this package and hence not included in the index.ts
 */
const changeIsLoading = action('changeIsLoading', (isLoading: boolean) => ({
    isLoading,
}));

export default changeIsLoading;
